import styled, { keyframes } from 'styled-components';

const swap = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const MissingIcon = styled.div`
  background-color: red;
  animation: ${swap} 1s infinite alternate;
  animation-timing-function: ease-out;
`;
